import React, { useState, useEffect } from "react";
import axios from "axios";
import { resetPassword } from "../services/auth";

const ResetPassword = () => {
  const [userId, setUserId] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [showConfirm, setShowConfirm] = useState(false);

  const handleReset = async () => {
    setShowConfirm(false);

    // Trim and validate
    const trimmedId = userId.trim();

    if (!trimmedId) {
      setStatus({ type: "error", message: "User ID cannot be empty." });
      return;
    }

    if (!/^\d+$/.test(trimmedId)) {
      setStatus({ type: "error", message: "User ID must be a number." });
      return;
    }

    try {
      setLoading(true);
      await resetPassword(Number(trimmedId)); // ensure it’s a number
      setStatus({
        type: "success",
        message: `પાસવર્ડ સફળતાપૂર્વક રીસેટ થયો છે (User ID: ${trimmedId})`,
      });
      setUserId("");
    } catch (error) {
      setStatus({
        type: "error",
        message: error.response?.data?.message || "Failed to reset password.",
      });
      console.error("Reset error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (status.message) {
      const timer = setTimeout(() => {
        setStatus({ type: "", message: "" });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [status.message]);

  return (
    <div className="p-8 max-w-md mx-auto">
      <h1 className="text-2xl font-semibold mb-4">Reset Password</h1>

      {status.message && (
        <div
          className={`mb-4 p-3 rounded ${
            status.type === "success"
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {status.message}
        </div>
      )}

      <input
        type="text"
        value={userId}
        onChange={(e) => {
          const val = e.target.value;
          if (/^\d*$/.test(val)) {
            setUserId(val); // Only allow digits
          }
        }}
        placeholder="Enter User ID"
        className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
      />

      <button
        onClick={() => setShowConfirm(true)}
        disabled={loading}
        className="mt-4 px-6 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 transition-colors disabled:opacity-50"
      >
        {loading ? "Resetting..." : "Reset Password"}
      </button>

      {/* Confirmation Modal */}
      {showConfirm && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full">
            <h2 className="text-lg font-semibold mb-4">
              Confirm Password Reset
            </h2>
            <p className="mb-4">
              શું તમે ખરેખર પાસવર્ડ રીસેટ કરવા માંગો છો?{" "}
              <strong>User ID: {userId}</strong>?
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowConfirm(false)}
                className="px-4 py-2 rounded-md bg-gray-200 hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleReset}
                className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;
